import autobind from 'autobind-decorator';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AnyAction, Dispatch } from 'redux';

import { KreoDialogActions } from 'common/UIKit';
import { FileUtils } from 'common/utils/file-utils';
import { AccountActions } from '../../../units/account/actions/creators';
import { ImageUploadZone } from './image-upload-zone';
import { RESTRICT_AVATAR_DIALOG_NAME, RestrictImageDialog } from './restrict-image-dialog';


interface OwnProps {
  previewUrl: string;
  defaultImagePreviewUrl?: string;
  deleteImage: () => void;
  // todo typedef
  onLoadEnd: (err: any, response?: any) => void;
  size?: string;
}

interface DispatchProps {
  imageInterceptor: (file: File) => void;
}

interface Props extends OwnProps, DispatchProps {}

export class ImageUploaderComponent extends Component<Props> {
  private imageUploadZone: React.RefObject<ImageUploadZone> = React.createRef();

  public render(): React.ReactNode {
    return (
      <>
        <ImageUploadZone
          previewUrl={this.props.previewUrl}
          defaultImagePreviewUrl={this.props.defaultImagePreviewUrl}
          ref={this.imageUploadZone}
          deleteImage={this.props.deleteImage}
          imageInterceptor={this.props.imageInterceptor}
          onLoadEnd={this.props.onLoadEnd}
          size={this.props.size}
        />
        <RestrictImageDialog onCrop={this.onCropImage} />
      </>
    );
  }

  @autobind
  private onCropImage(image: any): void {
    if (this.imageUploadZone) {
      const fileToSend = FileUtils.dataURItoBlob(image.toDataURL());
      this.imageUploadZone.current.upload(fileToSend);
    }
  }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>): DispatchProps {
  return {
    imageInterceptor: file => {
      dispatch(AccountActions.setAvatarFile(file));
      dispatch(KreoDialogActions.openDialog(RESTRICT_AVATAR_DIALOG_NAME));
    },
  };
}

export const ImageUploader = connect(null, mapDispatchToProps)(ImageUploaderComponent);
